/** **text muted** when 0,  **red** - negative balance, **green** - positive balance. */
const getBalanceColor = (balance, palette) => balance > 0
    ? { main: palette.success.dark, hover: palette.success.main }
    : balance < 0
        ? { main: palette.error.main, hover: palette.error.light }
        : { main: palette.text.muted, hover: palette.text.primary };
export { getBalanceColor };
